//文字コードはutf-8

/**
 * アプリケーション全体で使用する定数・設定値
 */

// ============================================
// ローダー関連の設定
// ============================================
export const LOADER = {
  // ローダーのタイムアウト時間（ミリ秒）
  TIMEOUT: 4000, // 3-5秒でタイムアウトさせUXを優先
  // ローダーフェードアウトアニメーション完了待ち時間（ミリ秒）
  FADEOUT_DELAY: 500,
  // ローダーフェードアウト後の処理遅延（ミリ秒）
  FADEOUT_POST_DELAY: 100,
  // ローダー要素のセレクタ
  SELECTOR: '.jsPageLoader'
};

// ============================================
// ビューポート監視関連の設定
// ============================================
export const VIEWPORT = {
  // ビューポート監視のマージン（px）
  MARGIN: 300
};

// ============================================
// 動画関連の設定
// ============================================
export const VIDEO = {
  // ループする秒数（デフォルト）
  LOOP_DURATION: 3,
  // ループ判定の閾値（秒）
  LOOP_THRESHOLD: 0.1
};

// ============================================
// アニメーション・遅延関連の設定
// ============================================
export const ANIMATION = {
  // ヘッダー色判定の遅延（ミリ秒）
  HEADER_COLOR_DELAY: 100
};

// ============================================
// Topページ KV部分専用の設定
// ============================================
export const TOP_KV = {
  // TopページKVイントロテキストのフェードアウトまでの遅延（ミリ秒）
  INTRO_FADEOUT_DELAY: 800,
  // TopページKVテキストエリア表示までの遅延（ミリ秒）
  TEXT_AREA_FADEIN_DELAY: 6500,
  // TopページKVテキストエリア表示までの遅延（ミリ秒）- 後方互換性のため残す
  TEXT_AREA_DELAY: 6500,
  // TopページKV再生フラグ設定の遅延（ミリ秒）
  PLAYBACK_FLAG_DELAY: 3000
};

